import React, { useState } from 'react';
import { ExpandMore } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import styles from './styles/styles.module.scss';

const Dropdown = ({ links }) => {
  return links.map(link => {
    return (
      <a key={link.label} href={link.linkPath} title={link.label} className={styles.dropdownLink}>
        {link.label}
      </a>
    );
  });
};

const LinkDropdown = ({ label, linkPath, dropdown = [] }) => {
  const [isOpen, toggleOpen] = useState(false);
  const hasDropdown = dropdown.length > 0;

  return (
    <>
      {hasDropdown ? (
        <>
          <button className={styles.buttonHeader} aria-expanded={isOpen} onClick={() => toggleOpen(!isOpen)} type="button">
            <span>{label}</span>
            <ExpandMore className={`${styles.expandMore} ${isOpen ? styles.expandMoreIsOpen : ''}`} />
          </button>
          <Collapse in={isOpen} collapsedHeight="0px" elementtype="div">
            <Dropdown links={dropdown} />
          </Collapse>
        </>
      ) : (
        <a className={styles.linkHeader} title={label} href={linkPath}>
          {label}
        </a>
      )}
    </>
  );
};

export default LinkDropdown;
